import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ExamLayout } from 'components';

class CtExamLayout extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { path, isDetailView } = this.props;

    return <ExamLayout currentPath={path.get('current')} beforePath={path.get('before')} isDetailView={isDetailView} />;
  }
}

const mapStateToProps = state => ({
  path: state.currentStatus.get('path'),
  isDetailView: state.currentStatus.get('isDetailView')
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CtExamLayout);



// WEBPACK FOOTER //
// ./src/script/containers/exam/CtExamLayout.js